var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "details-view",
      staticStyle: { overflow: "auto" },
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(170,170,170,0.5)"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "main-content",
          staticStyle: { width: "1150px", overflow: "unset" }
        },
        [
          _c("div", { staticClass: "section operations" }, [
            _c("div", { staticClass: "triggers" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.save } },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.cancel } },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ])
          ]),
          _c(
            "div",
            { staticClass: "section my-form" },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("Warehouse.JobNumberInformation")))
              ]),
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: true,
                    inline: true,
                    "label-width": "85px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessNo") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.job.jobNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "jobNo", $$v)
                          },
                          expression: "job.jobNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "MAWB No." } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.job.mbl,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "mbl", $$v)
                          },
                          expression: "job.mbl"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "HAWB No." } },
                    [
                      _c("el-input", {
                        attrs: { value: _vm.hawb ? _vm.hawb.hblNbr2 : "" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: true,
                    inline: true,
                    "label-width": "85px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "ETD" } },
                    [
                      _c("el-input", {
                        attrs: { value: _vm.job.etd.substr(0, 10) }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_AirlineCompany") }
                    },
                    [_c("el-input", { attrs: { value: _vm.carrierName } })],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FlightAndTime") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.job.voyageFlight,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "voyageFlight", $$v)
                          },
                          expression: "job.voyageFlight"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: true,
                    inline: true,
                    "label-width": "85px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_PortOfLoading") }
                    },
                    [_c("el-input", { attrs: { value: _vm.loadingPortName } })],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_DestinationPort") }
                    },
                    [
                      _c("el-input", {
                        attrs: { value: _vm.destinationPortName }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_AuthorizedClient")
                      }
                    },
                    [_c("el-input", { attrs: { value: _vm.customerName } })],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section my-form" },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("Warehouse.WarehouseInformation")))
              ]),
              _c(
                "el-form",
                {
                  staticStyle: { display: "flex" },
                  attrs: { "label-width": "85px", "label-position": "left" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-column" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_WarehouseNo"))
                              )
                            ]
                          ),
                          _c("cargo-input", {
                            attrs: { "auto-uppercase": true },
                            on: {
                              blur: function($event) {
                                _vm.warehouseIn.warehouseNo = _vm.warehouseIn.warehouseNo.trim()
                              }
                            },
                            model: {
                              value: _vm.warehouseIn.warehouseNo,
                              callback: function($$v) {
                                _vm.$set(_vm.warehouseIn, "warehouseNo", $$v)
                              },
                              expression: "warehouseIn.warehouseNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "required",
                          attrs: { label: _vm.$t("Warehouse.Warehouse") }
                        },
                        [
                          _c("cargo-input", {
                            attrs: { "auto-uppercase": true },
                            model: {
                              value: _vm.warehouseIn.warehouse,
                              callback: function($$v) {
                                _vm.$set(_vm.warehouseIn, "warehouse", $$v)
                              },
                              expression: "warehouseIn.warehouse"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Warehouse.Warehouseman") } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              "method-params": {
                                category: "role",
                                shape: "warehouseOp"
                              },
                              "default-value":
                                _vm.warehouseIn.warehouseOp || "",
                              placeholder: " "
                            },
                            on: {
                              change: function(p) {
                                _vm.warehouseIn.warehouseOp = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_EstimatedWarehousingTime"
                            ),
                            prop: "estimatedWarehousingTime"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.warehouseIn.estimatedWarehousingTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.warehouseIn,
                                  "estimatedWarehousingTime",
                                  $$v
                                )
                              },
                              expression: "warehouseIn.estimatedWarehousingTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "required",
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_ActualWarehousingTime"
                            ),
                            prop: "warehouseInDate"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.warehouseIn.warehouseInDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.warehouseIn,
                                  "warehouseInDate",
                                  $$v
                                )
                              },
                              expression: "warehouseIn.warehouseInDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_EstimatedDeliveryTime"
                            ),
                            prop: "estimatedDeliveryTime"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.warehouseIn.estimatedDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.warehouseIn,
                                  "estimatedDeliveryTime",
                                  $$v
                                )
                              },
                              expression: "warehouseIn.estimatedDeliveryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ActualDeliveryTime"),
                            prop: "warehouseOutDate"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.warehouseIn.warehouseOutDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.warehouseIn,
                                  "warehouseOutDate",
                                  $$v
                                )
                              },
                              expression: "warehouseIn.warehouseOutDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-column" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Warehouse.ReceiptNo") } },
                        [
                          _c("cargo-input", {
                            attrs: { "auto-uppercase": true },
                            model: {
                              value: _vm.warehouseIn.receiptNo,
                              callback: function($$v) {
                                _vm.$set(_vm.warehouseIn, "receiptNo", $$v)
                              },
                              expression: "warehouseIn.receiptNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Warehouse.DeliveryCmp") } },
                        [
                          _c("cargo-input", {
                            attrs: { "auto-uppercase": true },
                            model: {
                              value: _vm.warehouseIn.deliveryCmp,
                              callback: function($$v) {
                                _vm.$set(_vm.warehouseIn, "deliveryCmp", $$v)
                              },
                              expression: "warehouseIn.deliveryCmp"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Warehouse.LicensePlate") } },
                        [
                          _c("cargo-input", {
                            attrs: { "auto-uppercase": true },
                            model: {
                              value: _vm.warehouseIn.truckNo,
                              callback: function($$v) {
                                _vm.$set(_vm.warehouseIn, "truckNo", $$v)
                              },
                              expression: "warehouseIn.truckNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Warehouse.Driver") } },
                        [
                          _c("cargo-input", {
                            attrs: { "auto-uppercase": true },
                            model: {
                              value: _vm.warehouseIn.driver,
                              callback: function($$v) {
                                _vm.$set(_vm.warehouseIn, "driver", $$v)
                              },
                              expression: "warehouseIn.driver"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Warehouse.DriverPhone") } },
                        [
                          _c("cargo-input", {
                            attrs: { "auto-uppercase": true },
                            model: {
                              value: _vm.warehouseIn.driverTel,
                              callback: function($$v) {
                                _vm.$set(_vm.warehouseIn, "driverTel", $$v)
                              },
                              expression: "warehouseIn.driverTel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Warehouse.WarehouseLocation")
                          }
                        },
                        [
                          _c("cargo-input", {
                            attrs: { "auto-uppercase": true },
                            model: {
                              value: _vm.warehouseIn.location,
                              callback: function($$v) {
                                _vm.$set(_vm.warehouseIn, "location", $$v)
                              },
                              expression: "warehouseIn.location"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Warehouse.DeliveryMode") } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: " " },
                              model: {
                                value: _vm.warehouseIn.outType,
                                callback: function($$v) {
                                  _vm.$set(_vm.warehouseIn, "outType", $$v)
                                },
                                expression: "warehouseIn.outType"
                              }
                            },
                            _vm._l(_vm.WAREHOUSE_TYPES, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-column" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Warehouse.PalletSum") } },
                        [
                          _c("el-input-number", {
                            class:
                              _vm.warehouseIn.palletSum > 0
                                ? ""
                                : "empty-if-zero",
                            attrs: {
                              value:
                                _vm.warehouseIn.palletSum > 0
                                  ? _vm.warehouseIn.palletSum
                                  : undefined,
                              min: 0,
                              max: 10,
                              precision: 0,
                              "controls-position": "right"
                            },
                            on: {
                              input: function(value) {
                                _vm.warehouseIn.palletSum = value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.warehouseIn.receiveDc,
                                callback: function($$v) {
                                  _vm.$set(_vm.warehouseIn, "receiveDc", $$v)
                                },
                                expression: "warehouseIn.receiveDc"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Warehouse.ReceiveDc")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  _vm.warehouseIn.brokenQuantity = _vm
                                    .warehouseIn.broken
                                    ? _vm.warehouseIn.brokenQuantity
                                    : 0
                                }
                              },
                              model: {
                                value: _vm.warehouseIn.broken,
                                callback: function($$v) {
                                  _vm.$set(_vm.warehouseIn, "broken", $$v)
                                },
                                expression: "warehouseIn.broken"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Warehouse.IsNotComputationIsAffectedByDampness"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "Warehouse.ComputationIsAffectedByDampnessNum"
                            )
                          }
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              disabled: !_vm.warehouseIn.broken,
                              min: 0,
                              max: 99999,
                              precision: 0,
                              "controls-position": "right"
                            },
                            model: {
                              value: _vm.warehouseIn.brokenQuantity,
                              callback: function($$v) {
                                _vm.$set(_vm.warehouseIn, "brokenQuantity", $$v)
                              },
                              expression: "warehouseIn.brokenQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  _vm.warehouseIn.sealWeight = _vm.warehouseIn
                                    .sealCargo
                                    ? _vm.warehouseIn.sealWeight
                                    : 0
                                }
                              },
                              model: {
                                value: _vm.warehouseIn.sealCargo,
                                callback: function($$v) {
                                  _vm.$set(_vm.warehouseIn, "sealCargo", $$v)
                                },
                                expression: "warehouseIn.sealCargo"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Warehouse.IsTheGoodsClosed"))
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Warehouse.SealingWeight") } },
                        [
                          _c("el-input-number", {
                            class:
                              _vm.warehouseIn.sealWeight > 0
                                ? ""
                                : "empty-if-zero",
                            attrs: {
                              value:
                                _vm.warehouseIn.sealWeight > 0
                                  ? _vm.warehouseIn.sealWeight
                                  : undefined,
                              disabled: !_vm.warehouseIn.sealCargo,
                              min: 0,
                              max: 999999999999,
                              precision: 1,
                              "controls-position": "right"
                            },
                            on: {
                              input: function(value) {
                                _vm.warehouseIn.sealWeight = value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-column" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Warehouse.DescriptionOfGoods")
                          }
                        },
                        [
                          _c("cargo-input", {
                            attrs: {
                              "auto-uppercase": true,
                              type: "textarea",
                              rows: 4
                            },
                            model: {
                              value: _vm.warehouseIn.brokenDes,
                              callback: function($$v) {
                                _vm.$set(_vm.warehouseIn, "brokenDes", $$v)
                              },
                              expression: "warehouseIn.brokenDes"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("Warehouse.HandlingOpinions") }
                        },
                        [
                          _c("cargo-input", {
                            attrs: {
                              "auto-uppercase": true,
                              type: "textarea",
                              rows: 4
                            },
                            model: {
                              value: _vm.warehouseIn.comments,
                              callback: function($$v) {
                                _vm.$set(_vm.warehouseIn, "comments", $$v)
                              },
                              expression: "warehouseIn.comments"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Warehouse.Remark") } },
                        [
                          _c("cargo-input", {
                            attrs: {
                              "auto-uppercase": true,
                              type: "textarea",
                              rows: 4
                            },
                            model: {
                              value: _vm.warehouseIn.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.warehouseIn, "remarks", $$v)
                              },
                              expression: "warehouseIn.remarks"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section" },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("Warehouse.CargoDetails")))
              ]),
              _c("warehouse-detail-grid", {
                ref: "detailGrid",
                attrs: {
                  context: {},
                  action: "look",
                  job: _vm.job,
                  "warehouse-in": _vm.warehouseIn,
                  "open-imperial": _vm.openImperial
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section" },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("Warehouse.CargoPhotos")))
              ]),
              _c("warehouse-pic-grid", {
                ref: "picGrid",
                attrs: { model: _vm.warehouseIn },
                on: { uploadDone: _vm.uploadDoneHandler }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section" },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OperationRequirement")))
              ]),
              _c("warehouse-operation-req-data-grid", {
                attrs: { job: _vm.job },
                on: {
                  callback: function(value) {
                    _vm.operationfinishedItems = value
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _c("job-by-warehouse-dialog", {
        attrs: {
          visible: _vm.jobByWarehouseDialog.visible,
          jobs: _vm.jobByWarehouseDialog.jobs
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jobByWarehouseDialog, "visible", $event)
          },
          callback: _vm.jobByWarehouseDialog.callback
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }